/**
* Created by CHENRC2 on 2017-9-23.
*/
<template>
  <div class="paper layout-main" :style="{height: (screenHeight - 64) + 'px'}">
    <slot></slot>
  </div>
</template>
<style lang="less" scoped>
.paper {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px #a5abbc;
  display: block;
  margin: 10px;
  overflow: auto;
}
</style>
<script>
export default {
  data() {
    return {
      screenHeight:
        window.innerHeight > document.body.clientHeight ? window.innerHeight : document.body.clientHeight,
    };
  },
  watch: {
    screenHeight(val) {
      if (!this.timer) {
        this.screenHeight = val;
        this.timer = true;
        const that = this;
        setTimeout(() => {
          that.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    const that = this;
    window.onresize = () => (() => {
      that.screenHeight = window.innerHeight > document.body.clientHeight ? window.innerHeight : document.body.clientHeight;
    })();
  },
};
</script>
